import {RSAA} from "redux-api-middleware";
import {formatMatchPartsResult, formatMatchResult} from "./helpers";

export const CALENDAR_LOADING = 'CALENDAR_LOADING';
export const CALENDAR_SET_MATCHES = 'CALENDAR_SET_MATCHES';
export const CALENDAR_SET_DETAILS = 'CALENDAR_SET_DETAILS';
export const CALENDAR_CLOSE_DETAILS = 'CALENDAR_CLOSE_DETAILS';


const setMatchesAction = (matches) => ({
    type: CALENDAR_SET_MATCHES,
    payload: matches
});
const setDetailsAction = (matchDetails, match, achievements, isHeadToHeadAchievements) => ({
    type: CALENDAR_SET_DETAILS,
    payload: {
        matchDetails,
        match,
        achievements,
        isHeadToHeadAchievements
    }
});
export const fetchDetailsCloseAction = () => ({
    type: CALENDAR_CLOSE_DETAILS
});

export const fetchCalendarAction = (classId) => (dispatch, getState) =>
    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/game/${getState().games.current.id}/classification/${classId}/matches`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                CALENDAR_LOADING,
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => {
                        res.json().then(
                            json => {
                                dispatch(setMatchesAction(json.data.map(e => ({
                                    ...e,
                                    formattedPartsResults: formatMatchPartsResult(e),
                                    formattedResult: formatMatchResult(e),
                                }))));
                            }
                        )
                    }
                },
                'FAILURE'
            ]
        }
    });


export const fetchDetailsAction = (gameId, matchId) => (dispatch, getStore) =>
    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/game/${gameId}/match/${matchId}`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                dispatch(setDetailsAction(
                                    json.data,
                                    getStore().calendar.matches.find(e=> e.id === matchId),
                                    json.includes.achievements,
                                    json.meta.isHeadToHeadAchievements)
                                );
                            }
                        )
                    )
                },
                'FAILURE'
            ]
        }
    });
